<template>
  <v-app id="mnRegi" >
    <v-main>
      <v-container fluid> 
        <v-row>
          <v-col cols="3">
            <div class="title">
              Viewport management {{ this.regi_type }} areas
            </div>
            <div class="scroll">
              <v-expansion-panels>
                <v-expansion-panel v-for="(country,i) in landSkrg" :key="i">
                  <v-expansion-panel-header>
                    <div class="country-tab">
                      <country-flag :country="country.land_code" style="margin: 0;"/>
                      {{ country.landtaal_oms }}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div v-for="(regi,idx) in country.regions" :key="idx" class="mb-3">
                      <div class="park" :class="{'active': regi.regi_code === skrg.regi_code && (editType === 'Ski Area'||editType === 'Touristic Area')}" @click="clickSkrg(country.land_code, regi.regi_code)">
                        {{ regi.regi_oms }}
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-col>
          <v-col>
            <div class="maps-wrapper">
              <div class="control">
                <div class="pt-6 px-3 border-right font-weight-bold">
                  Show accommodations
                  <v-switch v-model="showAccos" class="mt-0" />
                </div>
                <div v-if="editType" class="py-6 px-3 border-right">
                  <div class="font-weight-bold">
                    Edit {{ editType }}
                  </div>
                  {{ skrg.regi_oms }}
                </div>
                <div style="display: flex; flex-direction: row; align-items: start;">
                  <div v-if="editType" class="px-3">
                    <v-btn elevation="2" @click="saveViewport">Save</v-btn>
                  </div>
                </div>
              </div>
              <div class="save-msg" :class="{'hide':!showSaveMsg}">
                Viewport for {{ skrg.regi_oms }} saved!
              </div>
              <GmapMap ref="maps" class="maps" :options="mapOptions" :zoom="6" :center="{lat: 48.040718, lng: 5.860905}" @idle="addMarkersToMap">
                <GmapRectangle v-if="viewportBounds.north" :options="rectangleOptions" :bounds="viewportBounds" @bounds_changed="rectBoundsChanged" />
                <GmapMarker v-for="marker in markers" :key="marker.accoId" :position="marker.position" :options="markerOptions" @click="openHuisInfo(marker.accoId)">
                  <GmapInfoWindow @closeclick="openHuisInfo('')" v-if="openedMarkerId === marker.accoId">
                    {{ marker.accoId }}
                  </GmapInfoWindow>
                </GmapMarker>
              </GmapMap>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>

<script>
import customMarker from '@/assets/maps-marker.svg'
import navBar from "@/components/ui/navbars/navbar.vue";
export default {
  components: {
    navBar
  },
  props: {
    regi_type: {
        type: String,
        required: true,
    }
  },
  data() { 
    return {
      landSkrg: [],
      viewportBounds: {},
      newBounds: {},
      editType: '',
      country: {},
      skrg: {},
      showAccos: false,
      markers: [],
      openedMarkerId: '',
      showSaveMsg: false,
      showInfo: false,
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        gestureHandling: 'greedy',
        styles: [{
          featureType: 'poi',
          elementType: 'labels',
          stylers: [
            { visibility: 'off' } // Hide all default poi labels
          ]
        }],
        zoomControlOptions: {
          position: 1 // Position top left
        }
      },
      rectangleOptions:{
        strokeOpacity: 0.8,
        strokeWeight: 2,
        strokeColor: 'red',
        fillColor: 'red',
        fillOpacity: 0.4,
        draggable: true,
        editable: true
      },
      markerOptions: {
        icon: customMarker
      }
    }
  },
  watch: {
    regi_type() {
        this.getLandSkrg();
    },
    showAccos(value) {
      if(value){
        this.addMarkersToMap()
      }else{
        this.markers = []
      }
    },
    showSaveMsg(value) {
      if(value){
        setTimeout(() => {
          this.showSaveMsg = false
        },3000)
      }
    }
  },
  methods: {
    addMarkersToMap(){
      if(!this.showAccos){ return }
      this.$refs.maps.$mapPromise.then(async (mapObject) => {
        const bounds = mapObject.getBounds().toJSON()
        const getMarkers = await this.$axios.post('https://api.villaforyou.com/getHuis',{ 
          bounds,
          from: 0,
          perPage: 1
        })
        this.markers = getMarkers.data.markers
      })
    },
    openHuisInfo(id) {
      this.openedMarkerId = id
    },
    rectBoundsChanged(newBounds){
      this.newBounds = {
        north: newBounds[Object.keys(newBounds)[0]].hi,
        south: newBounds[Object.keys(newBounds)[0]].lo,
        east: newBounds[Object.keys(newBounds)[1]].hi,
        west: newBounds[Object.keys(newBounds)[1]].lo
      }
    },
    clickSkrg(countryCode, regiCode){
      if (this.regi_type === "ski") {
        this.editType = 'Ski Area';
      } else {
        this.editType = 'Touristic Area';
      }
      this.country = this.landSkrg.find(x => x.land_code === countryCode)
      this.skrg = this.country.regions.find(x => x.regi_code === regiCode)
      this.viewportBounds = {
        north: this.skrg.regi_noordoost_lat,
        south: this.skrg.regi_zuidwest_lat,
        east: this.skrg.regi_noordoost_lng,
        west: this.skrg.regi_zuidwest_lng
      }
      this.$refs.maps.fitBounds(this.viewportBounds)
    },
    async getLandSkrg(){
      const getLandSkrg = await this.$axios.post("ares/json/ares/syst/skrg/getLandRegi.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getLandRegi"
        },
        getLandRegi: {
          regi_type: this.regi_type,
        }
      })
      this.landSkrg = getLandSkrg.data.getLandRegi
    },
    async saveViewport(){
      if(!this.editType){ return }
      if(!this.newBounds.north) { return }
      if(this.showSaveMsg) { return }
      const saveLandSkrg = await this.$axios.post("ares/json/ares/syst/skrg/saveLandSkrg.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "saveLandSkrg"
        },
        saveLandSkrg: {
          regi_type: this.regi_type,
          regiCode: this.skrg.regi_code || '',
          noordoost_lat: this.newBounds.north || 0,
          noordoost_lng: this.newBounds.east || 0,
          zuidwest_lat: this.newBounds.south || 0,
          zuidwest_lng: this.newBounds.west || 0
        }
      })
      if(saveLandSkrg.data.saveLandSkrg.saved){
        this.showSaveMsg = true
        this.getLandSkrg()
      }
    }, 
  },
  created() {
    this.$axios.post("ares/json/ares/misc/checkToken.p", {
      header: {
        token: this.$session.get("ARES"),
        clientSessionId: this.$session.id(),
        request: "checkToken"
      },
      checkToken: {}
    })
    .then(res => {
      if (res.data.error) {
        console.log(res.data.error);
        this.$session.destroy();
        this.$router.push("/");
      }   
    });
  },
  async mounted(){
    this.getLandSkrg()
  }
}
</script>

<style scoped>
.title{
  font-size: 23px;
  padding: 16px 24px;
  background-color: #f6f6f6;
}
.scroll{
  height: calc(100vh - 165px);
  overflow: scroll;
  padding: 0 2px;
}
.country-tab{
  display: flex;
  align-items: center;
  font-weight: bold;
}
.maps-wrapper{
  position: relative;
}
.control{
  position: absolute;
  top: 10px;
  left: 50px;
  height: 81px;
  z-index: 1;
  background-color: white;
  border-left: 1px solid #e6e6e6;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
}
.save-msg{
  position: absolute;
  top: 100px;
  left: 10px;
  z-index: 1;
  padding: 4px 12px;
  border-radius: 14px;
  background-color: #30ac30;
  color: white;
  font-weight: bold;
  transition: opacity 200ms ease-in-out;
}
.hide{
  opacity: 0;
}
.border-right{
  border-right: 1px solid #e6e6e6;
}
.maps{
  width: 100%;
  height: calc(100vh - 100px);
}
.park{
  font-weight:500;
  margin-left: 20px;
  cursor: pointer;
}
.province:hover{
  color:rgba(198, 32, 32, 0.8);
}
.active{
  color:rgb(198, 32, 32);
}
.placename{
  cursor: pointer;
}
.placename:hover{
  color:rgba(198, 32, 32, 0.8);
}
.region-checkbox{
  margin: 0;
  padding: 0;
}
</style>

